import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


import { BotonDGView } from "./boton";
import { esFolio, esClaveCliente } from "app/logic/guias";
import * as globals from "app/resources/globals";

function folioValido(x: string): boolean {
    return !x || esFolio(x);
}

const iconoBusqueda = require("app/img/iconos/facturacionicon.png");

type Entity = models.FacturacionOnlineParametros;
export interface State {
    value: Entity;
}

interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
}
class FacturacionView extends React.PureComponent<Props> {
    handleClick = () => {
        var { ClaveCliente, FolioGuia } = this.props.value;
        const value = this.props.value;

        if (esFolio(FolioGuia) && esClaveCliente(ClaveCliente)) {
            globals.setState(prev => ({ ...prev, facturacionOnline: { ClaveCliente: ClaveCliente, FolioGuia: FolioGuia } }));
            history.go("/facturacion");
        } else {
            kea.message("Error", "Error con información de guía", "error");
        }
    }

    handlePantalla = () => {
        history.go("/facturacion");
    }

    render() {
        const value = this.props.value;
        const colorInvalido = "#FFAAAA";
        const colorValido = "#BEE599";
        const colorTexto = (folio: string) =>
            esFolio(folio) ?
                colorValido : folio ? colorInvalido :
                    "white";

        const colorTextoClave = (clave?: number) =>
            clave && esClaveCliente(clave) ?
                colorValido : clave ? colorInvalido :
                    "white";

        return (
            <div
                style={{
                    width: "250px",
                    height: "250px",
                    background: "rgba(90,90,90, 1)",
                    display: "flex",
                    flexDirection: "row"
                }}
            >

                {/* Sangría */}
                <div style={{ flex: "0 1 auto", width: "23px" }} />

                <div style={{
                    display: "flex",
                    flexDirection: "column"
                }}>

                    {/* Titulo */}
                    <div style={{ display: "flex", flex: "0 1 auto", flexDirection: "column" }} >
                        <div style={{ flex: "0 1 auto", height: "20px" }} />
                        <div style={{ flex: "0 1 auto", textAlign: "left", fontWeight: "bold", fontSize: "16px", color: "white", fontFamily: "'Montserrat', sans-serif" }}>
                            FACTURACIÓN
                        </div>
                        <div style={{ flex: "0 1 auto", height: "20px" }} />
                    </div>


                    {/* Cuadros de texto */}
                    <div style={{ display: "flex", flexDirection: "row", flex: "0 1 auto" }}>
                        <div style={{ display: "flex", flexDirection: "column", flex: "0 1 auto" }}>
                            <div style={{ flex: "0 1 auto", textAlign: "left", fontWeight: "bold", fontSize: "12px", color: "white", fontFamily: "'Montserrat', sans-serif" }}>
                                Folio Guia:
                            </div>
                            <br />
                            <kea.Mask style={{
                                width: "138px",
                                height: "30px",
                                borderRadius: 0,
                                fontFamily: "monospace",
                                marginBottom: "6px",
                                backgroundColor: colorTexto(value.FolioGuia)
                            }}
                                value={value.FolioGuia}
                                onChange={x => this.props.onChange({ ... this.props.value, FolioGuia: x.toUpperCase() })}
                                mask={[
                                    { char: "alphanum", count: 3, trans: "upper" },
                                    "-",
                                    { char: "digito", count: 4 }
                                ]}
                            />
                            <br />

                            <div style={{ flex: "0 1 auto", textAlign: "left", fontWeight: "bold", fontSize: "12px", color: "white", fontFamily: "'Montserrat', sans-serif" }}>
                                Clave guía de cliente:
                            </div>
                            <br />
                            <kea.Number style={{
                                width: "138px",
                                height: "30px",
                                borderRadius: 0,
                                fontFamily: "monospace",
                                marginBottom: "6px",
                                backgroundColor: colorTextoClave(value.ClaveCliente)
                            }}
                                value={value.ClaveCliente}
                                onChange={x => this.props.onChange({ ... this.props.value, ClaveCliente: x! })}
                            />

                        </div>
                        <div style={{ flex: "0 1 auto", width: "12px" }} />
                        <div style={{ flex: "0 1 auto" }}>
                            <kea.IconButton>
                                <img src={iconoBusqueda} onClick={this.handlePantalla} title="Ver información facturación actual" />
                            </kea.IconButton>
                        </div>
                    </div>

                    {/* Botón facturar */}
                    <BotonDGView
                        style="pressed"
                        text="Facturar"
                        width="90px"
                        height="34px"
                        onClick={this.handleClick}
                        disableMargin
                    />
                </div>
            </div>
        )
    }
}

export class Facturacion extends React.PureComponent<{}, { value: Entity }> {
    constructor(props) {
        super(props);
        this.state = {
            value: {
                FolioGuia: ""
            }
        };
    }

    render() {
        return <FacturacionView value={this.state.value} onChange={x => this.setState({ value: x })} />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/diseño/items/facturaciononline.tsx